import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInviteTeam = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 40,
	height: 41,
	viewBox: "0 0 40 41",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			y: .597656,
			width: 40,
			height: 40,
			rx: 8,
			fill: "#E7ECEF"
		}),
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_18343_171684)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M24 30.5977V29.5977C24 27.3885 22.2091 25.5977 20 25.5977H14C11.7909 25.5977 10 27.3885 10 29.5977V30.5977",
					stroke: "#4D5055",
					strokeWidth: 1.5
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 17,
					cy: 18.5977,
					r: 4,
					stroke: "#4D5055",
					strokeWidth: 1.5
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M26.3335 9.59766V18.2643",
					stroke: "#4D5055",
					strokeWidth: 1.5,
					strokeLinecap: "square"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M30.6665 13.9307L21.9998 13.9307",
					stroke: "#4D5055",
					strokeWidth: 1.5,
					strokeLinecap: "square"
				})
			]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_18343_171684",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 24,
				height: 24,
				fill: "white",
				transform: "translate(8 8.59766)"
			})
		}) })
	]
});
export default SvgInviteTeam;
